// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2kfqr","label":"Completed_label__1uWj4"};